var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-title df-c"},[_c('img',{attrs:{"src":require("@/assets/images/bigscreenSales/title_icon.png"),"width":"32px","height":"32px"}}),_vm._v(" "),(_vm.month)?_c('div',{staticClass:"month"},[_vm._v(_vm._s(_vm.month))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9df125e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomTitle.vue
// module id = null
// module chunks = 